module.exports = __webpack_public_path__ + "static/img/14000782.4dcbfdb3.png";